import { Typography } from '@garner-health/components-common';
import { SR, useStringResource } from '@garner-health/lib-ui-content-management';
import NotSupportedSvg from 'jsx:~/assets/images/error-page.svg';
import React from 'react';

import { AppHeader } from '~/components';
import { SvgWithSubText } from '~/components/common';

const ErrorContent = () => {
  const header = useStringResource('main', 'errorPageHeader');

  return (
    <SvgWithSubText
      svg={<NotSupportedSvg role="img" aria-label={header} />}
      header={header}
      subHeader={
        <Typography variant="body1" color="common.muted">
          <SR package="main" id="errorPageSubheader" />
        </Typography>
      }
    />
  );
};

export const ErrorPage = () => (
  <>
    <AppHeader hideAccountButton />
    <ErrorContent />
  </>
);
